import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/prize-items/bulk/upload/upload_info", payload);
  },
};
